import React from 'react'
import { FaInstagram, FaLinkedin, FaTwitter } from 'react-icons/fa'
import { GrFacebook, GrSkype } from 'react-icons/gr'
import classes from './Footer.module.css'

const Footer = () => {
  return (
    <>
      <div className={'footer text-right ' + classes.footerContainer}>
        <div className='container'>
          <div className={classes.footerFlexContainer}>
            <div style={{ color: 'white' }}>
              <span>© {new Date().getFullYear()} Seeding Brains</span>
            </div>
            <div className={classes.footerIcons}>
              <a href='https://www.facebook.com/seedingbrains' target='_blank'>
                <GrFacebook size={30} />
              </a>
              <a
                href='https://www.instagram.com/seeding_brains/'
                target='_blank'
              >
                <FaInstagram size={30} />
              </a>
              <a
                href='https://www.linkedin.com/company/43228876/admin/'
                target='_blank'
              >
                <FaLinkedin size={30} />
              </a>
              {/* <a href='https://www.skype.com'>
                <GrSkype size={30} />
              </a>
              <a href='https://www.twitter.com'>
                <FaTwitter size={30} />
              </a> */}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Footer
